import { VF_BUTTON_SELECTOR } from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  INLINE_ERRORS,
  SILENT_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import moment from 'moment-timezone';
import { COMPLETE_WITHIN_APPROVED_WINDOW } from 'AppSrc/core/components/forms/form-types/completion-review/form-definition/section-constants';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import { actualStartDate } from '../section-two/actual-start-date';
import { actualEndDate } from '../section-two/actual-end-date';

const fieldId = COMPLETE_WITHIN_APPROVED_WINDOW;

const validator = (params) => {
  const {
    values,
    field,
    formData,
  } = params;
  const {
    'scheduled-start-date': scheduledStartDate,
    'scheduled-end-date': scheduledEndDate,
  } = formData.dataByFormSectionId.START_AND_END_DATE.dataByFieldId;

  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();


  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_BUTTON_SELECTOR);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? { withWarningSvg: true } : null);
  errors[SILENT_ERRORS].push((noValue && !optional) ? 'Please ensure you have answered all the questions in the Post Change Review.' : null);

  // define actualStart/EndMoment to check if it's before scheduledStart/EndMoment (the scheduled start/end date)
  if (values[actualStartDate.id] || values[actualEndDate.id]) {
    let isActualEndMomentOver;
    let isActualStartMomentOver;
    if (values[actualStartDate.id]) {
      const actualStartMoment = moment.tz(values[actualStartDate.id], DEFAULT_TIMEZONE).startOf('minute');
      const scheduledStartMoment = moment.tz(scheduledStartDate.value, DEFAULT_TIMEZONE).startOf('minute');
      isActualStartMomentOver = actualStartMoment.diff(scheduledStartMoment, 'minutes') > 0;
    }
    if (values[actualEndDate.id]) {
      const actualEndMoment = moment.tz(values[actualEndDate.id], DEFAULT_TIMEZONE).startOf('minute');
      const scheduledEndMoment = moment.tz(scheduledEndDate.value, DEFAULT_TIMEZONE).startOf('minute');
      isActualEndMomentOver = actualEndMoment.diff(scheduledEndMoment, 'minutes') > 0;
    }

    const isYes = values[fieldId][0] === 'Yes';
    if (isYes && (isActualStartMomentOver || isActualEndMomentOver)) {
      errors[INLINE_ERRORS].push('This question cannot be set to Yes when the actual change window is outside the scheduled change window');
      // errors[INLINE_ERRORS].push({ withWarningSvg: true });
      // errors[SILENT_ERRORS].push('This question cannot be set to Yes when the actual change window is outside the scheduled change window');
    }
  }

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = [];

const vFParams = {
  multiSelect: false,
  fieldTitle: 'Was it completed within the change window? Was there any additional impact?',
};

const mobilecompletedWithinChangeWindowWithoutAdditionalImpacts = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_BUTTON_SELECTOR,
};

export { mobilecompletedWithinChangeWindowWithoutAdditionalImpacts };
